import {
	FC,
	PropsWithChildren,
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
} from 'react';

type PostLoginDialogContextValue = {
	active: boolean;
	activate: () => void;
	dismiss: () => void;
};

const PostLoginDialogContext = createContext<PostLoginDialogContextValue>({
	active: false,
	activate: () => undefined,
	dismiss: () => undefined,
});

export const PostLoginDialogProvider: FC<PropsWithChildren> = ({ children }) => {
	const [active, setActive] = useState(false);
	const activate = useCallback(() => setActive(true), []);
	const dismiss = useCallback(() => setActive(false), []);
	const value = useMemo(() => ({ active, activate, dismiss }), [active, activate, dismiss]);
	return (
		<PostLoginDialogContext.Provider value={value}>{children}</PostLoginDialogContext.Provider>
	);
};

export const usePostLoginDialog = () => useContext(PostLoginDialogContext);
